@if (totalRecords()) {
  <div class="flex row paginator-container">
    <span class="mr-8">{{ 'Results on page:'|translate }}</span>
    <app-page-size-dropdown
      (pageSizeChanged)="pageSizeChanged($event)"
      [selectedOption]="pageSize"
      [pageSizeOptions]="pageSizeOptions">
    </app-page-size-dropdown>

    <span class="m-16">{{ 'PageOf'|translate:{ current: pageNum(), total: pagesCount } }}</span>

    <app-button
      [disabled]="pageNum() <= 1"
      [buttonStyleType]="ButtonTypes.SECONDARY_0"
      icon="icon-CaretLeft"
      aria-label="Previous"
      (clicked)="decreasePage()">
    </app-button>

    <app-button
      [disabled]="pageNum() >= pagesCount"
      [buttonStyleType]="ButtonTypes.SECONDARY_0"
      icon="icon-CaretRight"
      aria-label="Next"
      (clicked)="increasePage()">
    </app-button>
  </div>

}
